import type { ValueOf } from './base';

export const LOADING_STATES = {
  PRISTINE: 'pristine',
  LOADED: 'loaded',
  LOADING: 'loading',
  READY: 'ready',
  ERROR: 'error',
  EMPTY: 'empty',
} as const;

export type LoadingState = ValueOf<typeof LOADING_STATES>;
